<template>
    <div id="message_detail">
        <div class="message_detail">
            <div class="message_detail1">
                <div class="message_detail1_1 cursor_1" @click="goBack">
                    <img src="@/assets/image/icon_right.png" alt="">
                    小说详情
                </div>
                <div class="flex-row">
                    <div class="classroomDetailBtn" @click.stop="payClick">
                        <i class="el-icon-time t-m-r-5 t-font-16"></i>
                        灵感记录
                    </div>
                </div>
            </div>
            <div class="message_detail2">
                <div class="classroom-list t-m-t-20">
                    <div class="classroom-list__item">
                        <img class="cover" :src="result.cover" />
                        <div class="classroom-list__doc">
                            <div class="t-font-24 t-bold flex-row" style="color: #111111;">
                                {{ result.title }}
                                <p class="t-font-16 flex-row cursor_1" style="margin-left: 30px;font-weight: 400;"
                                    @click.stop="collectClick(result)">
                                    <img class="t-m-r-5" :src="result?.collect ? collectIcon[0] : collectIcon[1]"
                                        alt="" />
                                    <span :class="result?.collect ? 'sc' : ''">{{ result?.collect ? '已收藏' : '收藏' }}</span>
                                </p>
                            </div>
                            <p class="t-font-16 flex-row" style="color: #333333;margin-top: 18px;"><img
                                    :src="`https://api.esrke.com/icon/platform/${result.platform}.png`" width="20"
                                    height="20" /><span class="t-m-l-20">作者：{{ result.author }}</span></p>
                            <p class="flex-row t-font-16" style="color: #333333;margin-top: 5px;">{{
                                result.status ? '已完结' : '连载中' }}&nbsp;&nbsp;&nbsp;&nbsp;{{ result.chapters
                                }}章&nbsp;&nbsp;&nbsp;&nbsp;{{
                                    $validata.formatNumberToUnit(result.words, 1) }}字</p>
                            <p class="t-font-16" style="color: #333333;margin-top: 5px;">阅读量：{{
                                $validata.formatNumberToUnit(result.reads, 1) }}</p>
                            <p class="hottc-categorys">{{ result.categorys }}</p>
                            <div class="flex-row">
                                <div v-if="result.platform === 'fq'" @click.stop="linkJump"
                                    class="chapter-zw-blur t-m-r-22">阅读全文</div>
                                <div @click.stop="toAICreate" class="classroomBtn aisclg">AI 生成灵感</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="jianjie">
                    <p>书籍简介</p>
                    <p>
                        {{ result.introduction }}
                    </p>
                </div>
            </div>
        </div>
        <Pay ref="payMoney"></Pay>
        <RightDisplayArea :showApp="true"></RightDisplayArea>
        <textRequire ref="textRequire" requireTitle="灵感要求" placeholder="请输入您的灵感特定要求，如：种田文融入真假千金的元素 (如无要求，可不填)"></textRequire>
    </div>
</template>
<script>
import data from '@/assets/data';
import HApi from '@/api/hottc';
import { EventBus } from '@/utils/eventBus'
import Pay from '@/components/classroom/pay.vue'
import RightDisplayArea from '@/components/dongeb/RightDisplayArea.vue'
import textRequire from '@/components/text_require.vue'// 要求
export default {
    components: {
        Pay, RightDisplayArea, textRequire
    },
    data() {
        return {
            result: {},
            uid: '',
            collectIcon: data.collectIcon,//收藏图标
        }
    },
    mounted() {
        let { uid } = this.$route.query
        if (uid) {
            this.uid = uid
            this.getDetail()
        }
        this.getUserLoginState(false)
        EventBus.$on('getRequire', (requirement) => {
            console.log('监听到了=',requirement)
            const params = {
                editType: 2,
                isAiCreate: true,
                uid: this.uid,
                requirement:requirement||'无'
            }
            sessionStorage.setItem('rm_editItem', JSON.stringify(params))
            this.$router.push({ path: '/hottc_result', query: { uid: this.uid } })
        })
    },
    beforeDestroy() {
        EventBus.$off('getRequire')
    },
    methods: {
        getDetail() {
            HApi.novelDetail(this.uid).then(res => {
                if (res.code === 200) {
                    this.result = res.data || {}
                    if (!this.result.display) {
                        this.$message.warning('当前作品已经关闭')
                        this.goBack()
                    }
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        goBack() {
            this.$router.go(-1)
        },
        payClick() {
            if (this.loginState) {
                EventBus.$emit('openLogin')
                return
            }
            this.$router.push({ path: '/hottc_history', query: { uid: this.result.uid, title: this.result.title } })
        },
        linkJump() {
            if (this.result && this.result.platform === 'fq') {
                window.open(this.result.link)
            }

        },
        toAICreate() {
            if (this.loginState) {
                EventBus.$emit('openLogin')
                return
            }
            this.$refs.textRequire.openPrompt('','生成灵感')
        },
        collectClick(item) {
            //取消收藏
            if (item.collect) {
                HApi.closeCollect(item.uid).then(res => {
                    if (res.code == 200) {
                        this.$message.success('取消收藏成功！')
                        item.collect = false
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            } else {
                //收藏
                HApi.openCollect(item.uid).then(res => {
                    if (res.code == 200) {
                        item.collect = true
                        this.$message.success('收藏成功！')
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            }
        }
    }

}
</script>

<style lang="scss" scoped>
p {
    margin: 0;
    padding: 0;
}

#message_detail {
    flex: 1;
    height: 100%;
    padding: 0 0 0 20px;
    font-size: 15px;
}

.message_detail {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
}

.message_detail1 {
    display: flex;
    align-items: center;
    height: 65px;
    border-bottom: 1px solid #E6EBF0;
    padding: 0 20px;
    position: relative;
    justify-content: space-between;
}

.message_detail1_1 {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    color: #111111;
}

.message_detail1_1 img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
}

.classroom-list {
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 32px;
    border-bottom: 1px solid #E6EBF0;
}

.classroom-list__item {
    width: 100%;
    // border-radius: 12px;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;

    .cover {
        width: 180px;
        height: 240px;
        flex-shrink: 0;
        border-radius: 4px;
        object-fit: cover;
    }
}

.classroom-list__doc {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: .25rem .75rem 0 1.5625rem;
    box-sizing: border-box;
}

.hottc-categorys {
    padding: 0 10px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    margin: 1.0625rem 0;
    background: #F8F8F8;
    border-radius: 4px;
    font-size: 16px;
    color: #666666;
    width: fit-content;
}

.chapter-zw-blur {
    width: 150px;
}

.aisclg {
    background-color: #FFFFFF;
    border: var(--tech-primary);
    color: var(--tech-primary);
    border-radius: 16px;
    padding: 0 15px;
    width: 150px;
    font-size: 15px;
    height: 33px;
}

.jianjie {
    p:first-child {
        font-size: 20px;
        color: #000;
        margin: 30px 0;
    }

    p:last-child {
        font-size: 16px;
        color: #000;
        padding-right: 50px;
    }
}

.sc {
    color: var(--tech-primary);
}
</style>